import { useState,useEffect } from 'react'
import { Button, TextField } from '@mui/material'
import { Link } from 'react-router-dom'

const FastPayment = () => {

    const [terminal,setTerminal] = useState('')

    const submit = e => {
        e.preventDefault()
        window.open(`https://ipg.sabinarya.com/payment/ipg/qr/app/?terminalNumber=${terminal}&callback=${process.env.REACT_APP_TRANSACTION_CALLBACK_URL_WITHOUT_LOGIN}`,'_blank')
    }

    useEffect(() => {
        if(terminal && terminal.length){
            if(terminal.includes('۰'))
                setTerminal(terminal.replace(/۰/g,'0'))
            if(terminal.includes('۱'))
                setTerminal(terminal.replace(/۱/g,'1'))
            if(terminal.includes('۲'))
                setTerminal(terminal.replace(/۲/g,'2'))
            if(terminal.includes('۳'))
                setTerminal(terminal.replace(/۳/g,'3'))
            if(terminal.includes('۴'))
                setTerminal(terminal.replace(/۴/g,'4'))
            if(terminal.includes('۵'))
                setTerminal(terminal.replace(/۵/g,'5'))
            if(terminal.includes('۶'))
                setTerminal(terminal.replace(/۶/g,'6'))
            if(terminal.includes('۷'))
                setTerminal(terminal.replace(/۷/g,'7'))
            if(terminal.includes('۸'))
                setTerminal(terminal.replace(/۸/g,'8'))
            if(terminal.includes('۹'))
                setTerminal(terminal.replace(/۹/g,'9'))
        }
    },[terminal])

    return (
        <form className="auth-container" onSubmit={e => submit(e)}>
            <h2 className="auth-page-title">پرداخت سریع</h2>
            <TextField type="tel" className="ltr-input" sx={{mb: 2}} fullWidth={true} inputProps={{maxLength: 11}} label="شماره پایانه" variant="standard" value={terminal} onChange={e => setTerminal(e.target.value)} />
            <Button type="submit" fullWidth={true} sx={{mt: 3,py: 1.5}} className="custom-btn-primary" variant="contained" disabled={!terminal} onClick={submit}>پرداخت</Button>
            <p className="auth-page-footer">حساب کاربری دارید ؟ <Link to="/auth/login">وارد شوید</Link></p>
            <p className="auth-page-footer">حساب کاربری ندارید ؟ <Link to="/auth/register">احراز هویت</Link></p>
        </form>
    )
}

export default FastPayment